//-------------------------------------------------------------------------------------------------- Imports
import { PayloadAction, createSlice } from "@reduxjs/toolkit";


//-------------------------------------------------------------------------------------------------- Interfaces
interface UpdatePasswdSliceInterface {
    show: boolean;
};



//-------------------------------------------------------------------------------------------------- Vars and consts
const updatePasswdSliceInitialState = {
    show: false,
} as UpdatePasswdSliceInterface;



//-------------------------------------------------------------------------------------------------- Slice
const updatePasswordSlice = createSlice({
    name: "updatePassword",
    initialState: updatePasswdSliceInitialState,
    reducers: {
        setUpdatePasswd: (state, action: PayloadAction<UpdatePasswdSliceInterface>) => {
            state.show = action.payload.show;
        },
        showUpdatePasswd: (state, action: PayloadAction<boolean>) => {
            state.show = action.payload;
        },
        clearUpdatePasswd: (state) => {
            state.show = updatePasswdSliceInitialState.show;
        }
    }
});



//-------------------------------------------------------------------------------------------------- Exports
export const {showUpdatePasswd, setUpdatePasswd, clearUpdatePasswd} = updatePasswordSlice.actions;
export const getUpdatePasswdData = (state: any) => (state.updatePassword) as UpdatePasswdSliceInterface;
export default updatePasswordSlice.reducer;
